import { createFileRoute } from "@tanstack/react-router";

import OnboardingPage from "@/components/[routes]/onboarding/onboarding-page";
import { RouteGuards } from "@/core/auth/route-guards";

export const Route = createFileRoute("/_secure/onboarding")({
  beforeLoad: RouteGuards.adminOnly(),
  component: OnboardingPage,
});
